<app-dialog-base [Title]='"Group settings"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate }}</label>
    <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="object.Name"/>
  </div>
  <div class="inputgroup" *ngIf="containers.length">
    <label>{{'Container'|translate }}</label>
    <input *ngIf="readonlyContainer" type="text" [value]="getSelectedContainerName()" readonly />
    <select *ngIf="!readonlyContainer" [(ngModel)]="object.ContainerId">
      <option *ngFor="let container of containers" [ngValue]="container.Id">{{container.Name}}</option>
    </select>
  </div>
  <div class="tableheader">{{'Objects'|translate}}</div>
  <div class="tablewrap admindrivers">
    <div class="table">
      <table fixedcols="[0]">
        <tr>
          <th>
            <switch-all-checkbox [items]="objects" />
          </th>
          <th style="max-width: 560px">{{'Name'|translate }}</th>
          <th>
            <button class="btnadd" (click)="addObjects()"></button>
          </th>
        </tr>
        <tr *ngFor="let object of objects">
          <td>
            <input type="checkbox" [(ngModel)]="object.IsChecked" (change)="onToggle(object)"/>
          </td>
          <td>{{object.Name}}</td>
          <td>
            <button class="btn_img btn_trush " (click)="deleteObject(object)"></button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</app-dialog-base>
